import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { getSessionId } from "../../../utils/tokenHandlers";
import { getAllCurrencies } from "../../../feature/apis/currency/getAllCurrencies";
import { getLocalBankCurrencies } from "../../../feature/apis/currency/getLocalBankCurrencies";

interface LocalBankCurrenciesProps {
  name: string;
  label: string;
  register: any;
  required?: boolean;
  requiredMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultValue?: string;
  error?: string;
  disabled?: boolean;
}

interface LocalBankCurrenciesData {
  id: number;
  sr_no: number;
  currency_name: string;
  currency_code: string;
  master_status: string;
  transaction_status: string;
}

const LocalBankCurrencies: React.FC<LocalBankCurrenciesProps> = ({
  name,
  label,
  register,
  required,
  requiredMessage = "This field is required",
  onChange,
  defaultValue,
  disabled,
  error,
}) => {
  const token = getSessionId();

  const [localBankCurrencyValues, setLocalBankCurrencyValues] = useState<
    LocalBankCurrenciesData[]
  >([]);

  useEffect(() => {
    getLocalBankCurrencies(token).then((response) => {
      //// console.log("REGISTER WITH --> ", response);
      setLocalBankCurrencyValues(response.result.result);
    });
  }, []);

  return (
    <Form.Group as={Col} className="mb-3">
      <Row className="align-items-center">
        <Form.Label column md={4}>
          <span className="float-end">
            {label}&nbsp;
            <span className="text-danger form-label">
              {required ? "*" : ""}
            </span>
            :
          </span>
        </Form.Label>
        <Col md={8}>
          <Form.Select
            as="select"
            className={`custom-input form-control ${error ? "is-invalid" : ""}`}
            defaultValue={defaultValue}
            disabled={disabled}
            {...register(name, {
              required: required ? requiredMessage : false,
              onChange: (e: any) => {
                if (onChange) onChange(e); // call custom onChange
              },
            })}
          >
            <option value="">Select Option</option>
            {localBankCurrencyValues.map((localBankCurrencyValue, index) => (
              <option key={index} value={localBankCurrencyValue.id}>
                {localBankCurrencyValue.currency_code}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={4}></Col>
        <Col md={8}>{error && <p className="m-0 err-msg">{error}</p>}</Col>
      </Row>
    </Form.Group>
  );
};

export default LocalBankCurrencies;
